<template>
  <div class="card-p">
    <ul>
      <template v-for="(item,index) in data">
        <li @click="goPageBack(item)">
          <img :src="item.imgUrl">
          <div class="ac-title">{{ item.name  }}</div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "event-review",
    props: {
      data: {
        type: Array,
        default: []
      }
    },
    data () {
      return {
        activtyList: [
          {imgUrl:'https://cdn.huodongxing.com/logo/201912/9525104651200/683647812167307_v2small.jpg', name:'「听未来物流的声音」亚洲物流双年展·2020新年酒会'},
          {imgUrl:'https://cdn.huodongxing.com/logo/201912/5525693386800/773650741477026_v2small.jpg', name:'Hit-Talk | 职教行业闭门论坛Hit-Talk | 职教行业闭门论坛Hit-Talk | 职教行业闭门论坛'},
          {imgUrl:'https://cdn.huodongxing.com/logo/201912/8525661160500/313650435224047_v2small.jpg', name:'洞察2020：新形势，新升级'},
          {imgUrl:'https://cdn.huodongxing.com/logo/202001/5526228387500/363654490135071_v2small.jpg', name:'瀚海企业融资系列课堂之债权融资培训'},
          {imgUrl:'https://cdn.huodongxing.com/logo/202001/4526138768100/113653749021065_v2small.jpg', name:'2020年中国企业用工升级研讨会'},
          {imgUrl:'https://cdn.huodongxing.com/logo/201912/6525306448312/743651608371243_v2small.jpg', name:'周二 黑胶·Tango·威士忌 阿根廷Tango邂逅'},
          {imgUrl:'https://cdn.huodongxing.com/logo/201910/3514898277700/243654866010918_v2small.jpg', name:'第九届（2019）CSR年度盛典'},
          {imgUrl:'https://cdn.huodongxing.com/logo/201912/1525144052611/893646838344668_v2small.jpg', name:'丁香通线上公开课 | 2020年体外诊断行业发展趋势和动态解读'},          {imgUrl:'https://cdn.huodongxing.com/logo/201912/9525104651200/683647812167307_v2small.jpg', name:'「听未来物流的声音」亚洲物流双年展·2020新年酒会'},
          {imgUrl:'https://cdn.huodongxing.com/logo/201912/5525693386800/773650741477026_v2small.jpg', name:'Hit-Talk | 职教行业闭门论坛'},
          {imgUrl:'https://cdn.huodongxing.com/logo/201912/8525661160500/313650435224047_v2small.jpg', name:'洞察2020：新形势，新升级'},
          {imgUrl:'https://cdn.huodongxing.com/logo/202001/5526228387500/363654490135071_v2small.jpg', name:'瀚海企业融资系列课堂之债权融资培训'},
          {imgUrl:'https://cdn.huodongxing.com/logo/202001/4526138768100/113653749021065_v2small.jpg', name:'2020年中国企业用工升级研讨会'},
          {imgUrl:'https://cdn.huodongxing.com/logo/201912/6525306448312/743651608371243_v2small.jpg', name:'周二 黑胶·Tango·威士忌 阿根廷Tango邂逅'},
          {imgUrl:'https://cdn.huodongxing.com/logo/201910/3514898277700/243654866010918_v2small.jpg', name:'第九届（2019）CSR年度盛典'},
          {imgUrl:'https://cdn.huodongxing.com/logo/201912/1525144052611/893646838344668_v2small.jpg', name:'丁香通线上公开课 | 2020年体外诊断行业发展趋势和动态解读'},
        ]
      }
    },
    methods: {
      goPageBack (params) {
        this.$emit('goPage',params)
      }
    }
  }
</script>

<style scoped>
  .card-p {
    width: 100%;
    margin-right: 0;
    margin-bottom: 32px;
    background-color: #ffffff;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    border: solid 1px #eeeeee;
    padding-top: 30px;
    padding-left: 30px;
    /*padding-right: 30px;*/
  }
  .card-p ul{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    box-sizing: border-box;
    /*justify-content: space-between;*/
    /*justify-content: space-between;*/
    margin: 0;
    padding: 0;
    width: 100%;
  }
  .card-p ul li{
    width: 22%;
    margin-right: 3%;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 19px;
    color: #5c5c5c;
    cursor: pointer;
  }
  .card-p ul li img{
    width:100%;
    height: 148px;
    margin-bottom: 8px;
    border-radius: 4px;
  }
  .ac-title{
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
</style>



// WEBPACK FOOTER //
// src/pages/activty/event-review.vue